import React from "react";

export default function PlaceAutocompleteOption({query, place}) {
    if (!query) return place?.text?.text;

    const regex = new RegExp(`(${query})`, "gi");
    const parts = place.text.text.split(regex);

    return <div>
        {parts.map((part, index) =>
        regex.test(part) ? (
            <span
                key={index}
                className="font-black text-tm-gray-900"
            >
                {part}
            </span>
        ) : (
            part
        )
    )}
    </div>
}